import React from 'react';
import ScrollEffectWrapper from './ScrollEffectWrapper';
import SkillCard from './SkillCard';
import skills from '../data/skills';

function SkillsSection() {
  return (
    <section className="section skills-section">
      <div className="container">
        <ScrollEffectWrapper animationType="title">
          <div className="section-header">
            <h2 className="section-title">Skills & Expertise</h2>
            <p className="section-subtitle">Technologies and professional capabilities</p>
          </div>
        </ScrollEffectWrapper>

        <div className="skills-grid">
          {skills.map((skill, index) => (
            <ScrollEffectWrapper key={skill.title} animationType="slide-up" delay={index * 120}>
              <SkillCard skill={skill} />
            </ScrollEffectWrapper>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SkillsSection;
